import React, { useEffect, useState } from 'react';
import styled, { withTheme } from 'styled-components';
import { Button } from 'components/Button';
import { ContainerWrapper } from 'components/Card/cardStyle';
import Container from 'components/Container';
import ContainerHeader from 'components/ContainerHeader';
import { SearchInput } from 'components/Form/SearchInput';
import Pagination from 'components/Pagination';
import { Table } from 'components/Table';
import Text from 'components/Text';
import {
  withEventYearFilterContext,
  YearDropdown,
} from 'components/YearDropdown';
import { useUpdateQueryString } from 'hooks/useSearchInput';
import { IssueCreditModal } from 'pages/app/Credits/issueCreditModal';
import { TitleContainer } from 'pages/track/Contact/style';
import { useGetUserExpiredCreditsByAccount } from './gql/get-user-expired-credits-by-account';

const CreditButton = styled.div`
  padding: 0;
  margin-left: auto;
  margin-right: 40px;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  &:focus {
    outline: 0;
  }
`;

const FilterContainer = styled.div`
  min-width: 150px;
`;

const TrackExpiredCreditsDetail = withEventYearFilterContext(() => {
  const [expiredCredits, setExpiredCredits] = useState();
  const [countExpired, setCountExpired] = useState();
  const [search, setSearch] = useState('');

  const [showIssueCredit, setShowIssueCredit] = useState(false);

  const { res, loading } = useGetUserExpiredCreditsByAccount();

  useEffect(() => {
    if (res && res.getUserExpiredCreditsByAccount) {
      setExpiredCredits(res?.getUserExpiredCreditsByAccount?.results);
      setCountExpired(res?.getUserExpiredCreditsByAccount?.count);
    }
  }, [res]);

  const updateQueryString = useUpdateQueryString();

  const handleChange = (e) => setSearch(e.target.value);

  const handleBlur = (e) => {
    updateQueryString(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      updateQueryString(e.target.value);
    }
  };

  const columns = [
    {
      label: 'Ticket Holder',
      key: 'ticketHolder',
    },
    {
      label: 'Credit',
      key: 'credit',
    },
    {
      label: 'Credit #',
      key: 'creditNum',
    },
    {
      label: 'Issued',
      key: 'issued',
    },
  ];

  const urlParams = new URLSearchParams(window.location.search);
  const currentPage = parseInt(urlParams.get('page'));

  function renderRows(credit) {
    const { id, user, amount, date } = credit;

    const userName = user.formatted_name;
    // const issuer = issued_by.formatted_name;

    return {
      ticketHolder: userName,
      credit: amount.toString(),
      creditNum: id,
      issued: date,
      // issuedBy: issuer,
    };
  }

  return loading ? (
    <div />
  ) : (
    <>
      <Container>
        <ContainerHeader>
          <ContainerWrapper>
            <TitleContainer>
              <Text
                type="heading"
                color="#3C4144"
                inlineStyle={{ marginRight: 25, marginTop: 10 }}
              >
                Expired Credits
              </Text>

              <FilterContainer>
                <YearDropdown showLabel={false} />
              </FilterContainer>
              <SearchInput
                placeholder="Search Credits"
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={handleKeyPress}
                value={search}
                style={{ width: 150, marginLeft: 15 }}
              />
            </TitleContainer>
            <CreditButton>
              <Button
                // eslint-disable-next-line no-console
                onClick={() => setShowIssueCredit(true)}
                buttonStyle={{ height: 35 }}
              >
                {'Issue Credit'}
              </Button>
            </CreditButton>
          </ContainerWrapper>
        </ContainerHeader>
        {!expiredCredits ? (
          <div />
        ) : (
          <>
            <Table
              items={expiredCredits}
              columns={columns}
              renderRows={renderRows}
            />
            <Pagination
              count={countExpired}
              perPage={15}
              currentPage={currentPage || 1}
            />
          </>
        )}
      </Container>
      <IssueCreditModal
        setIsVisible={setShowIssueCredit}
        isVisible={showIssueCredit}
        isTrackAdmin={true}
      />
    </>
  );
});

export default withTheme(TrackExpiredCreditsDetail);
